import { focusVisible, hoverBgColor, textColor, bgColor } from "../../Resources/CSS/styling";
import { useTranslation } from "../../Translation";
import Dropdown from "../Dropdown";
import Pagination from "./Pagination";
import { renderColumn, useColumns } from "./Table";

export default function GridTable(props) {

    const { title, description, createButton, data, translationKey, dropdownGroups, actions } = props;
    const columnsPassed = props.columns;
    const pagination = props.pagination;

    const { columns, setColumnOrdered } = useColumns(data, columnsPassed);

    const { translate } = useTranslation();

    return (
        <div>
            <div className="px-4 sm:px-6 lg:px-8">
                <div className="sm:flex sm:items-center">
                    <div className="sm:flex-auto">
                        <h1 className="text-base font-semibold text-gray-900">{title}</h1>
                        <p className="mt-2 text-sm text-gray-700">
                            {description}
                        </p>
                    </div>
                    <div className="mt-4 sm-ml-16 sm:mt-0 sm:flex-none flex-row flex gap-x-4">
                        {actions && actions.length > 0 && <div className="flex flex-row">
                            {actions.map((action, index) => (
                                <button
                                    key={'action-' + translate(translationKey + '.' + action.text) + index}
                                    onClick={action.action}
                                    type="button"
                                    className={`ml-3 block rounded-md ${bgColor} px-3 py-2 text-center text-sm font-semibold text-white shadow-sm ${hoverBgColor} focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${focusVisible}`}
                                >
                                    {action.text}
                                </button>
                            ))}
                        </div>}
                    </div>
                </div>
                <div className="mt-8 flow-root">
                    <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                            <table className="min-w-full divide-y divide-gray-300">
                                <thead>
                                    <tr className="divide-x divide-gray-200">
                                        {columns.map((column, index) => (
                                            <th key={column.key} scope="col" className={`py-3.5 pr-4 text-left text-sm font-semibold text-gray-900 ${index > 0 ? 'pl-4' : ''}`}>
                                                {translate(translationKey + '.' + column.key)}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-200 bg-white">
                                    {data.map((item) => (
                                        <tr key={item.key || item.id} className="hover:bg-gray-100 cursor-pointer even:bg-gray-50 divide-x divide-gray-200" onClick={() => {
                                            if (props.onRowClick) {
                                                props.onRowClick(item);
                                            }
                                        }}>
                                            {columns.map((column, index) => (
                                                <td className={index === 0 ? 'whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0' : 'whitespace-nowrap px-3 py-4 text-sm text-gray-500'}>
                                                    {renderColumn(column, index, item)}
                                                </td>

                                            ))}
                                            {dropdownGroups && dropdownGroups.length > 0 && <td className="flex flex-row whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm sm:pr-0 items-end justify-end">
                                                <Dropdown row={item} groups={dropdownGroups} />
                                            </td>}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div className="px-4 sm:px-6 lg:px-8">
                {pagination && <Pagination pagination={pagination} />}
            </div>
        </div>

    )
}
